var thumbnails_swiper = new Swiper(".thumbnails-swiper", {
  spaceBetween: 0,
  slidesPerView: 3,
  watchSlidesProgress: true,
  navigation: {
    nextEl: "#next-thumb",
    prevEl: "#prev-thumb",
  },
});

var images_swiper = new Swiper(".images-swiper", {
  spaceBetween: 0,
  loop: true,
  navigation: {
    nextEl: "#swiper-b-nxt",
    prevEl: "#swiper-b-prv",
  },
  thumbs: {
    swiper: thumbnails_swiper,
  },
});

images_swiper.on("click", (s, e) => {
  if(window.innerWidth < 700) return
  const index = s.activeIndex;
  zoom_swiper.slideTo(index, 0, false);
  $zoom_.classList.add("active");
  document.body.classList.add('d-s');
});

var zoom_swiper = new Swiper(".zoom-swiper", {
  spaceBetween: 0,
  slidesPerView:1,
  loop: true,
  pagination: {
    el: ".zoom_pag span",
    type: "fraction",
  },
  navigation: {
    nextEl: "#zoom-gallery-next",
    prevEl: "#zoom-gallery-prev",
  },
});

const $zoom_close_btn = document.querySelector(".zoom_close");
const $zoom_ = document.querySelector(".zoom_");
$zoom_close_btn.addEventListener("click", () => {
  $zoom_.classList.remove("active");
  document.body.classList.remove('d-s');
});
